export default function convertToPaths (obj, prefix) {
  const converted = convert(obj)
  return Object.keys(converted)
    .filter(path => converted[path] != null) // drop any null/undefined values
    .reduce(
      (out, path) => ({
        ...out,
        [prefix ? `${prefix}.${path}` : path]: converted[path]
      }),
      {}
    )
}

export function convert (obj, prefix = '') {
  if (
    typeof obj !== 'object' ||
    obj == null ||
    (Array.isArray(obj) && !obj.length)
  ) {
    return obj
  }
  return Object.keys(obj).reduce((paths, key) => {
    const value = obj[key]
    const path = prefix ? `${prefix}.${key}` : key
    if (Array.isArray(value) && !value.length) {
      return { ...paths, [path]: [] }
    }
    if (value === null) {
      return { ...paths, [path]: null }
    }
    if (typeof value === 'object') {
      return { ...paths, ...convert(value, path) }
    }
    return { ...paths, [path]: value }
  }, {})
}
